import api from './api';
import { AppointmentCreateData } from '../types/appointment.types';
import { ProfessionalService } from '../types/bookingWizard.types';

export const bookingWizardService = {
    getProfessionalServices: async (professionalId: number): Promise<ProfessionalService[]> => {
        const response = await api.get('/professional-services/', {
            params: { professional: professionalId }
        });
        return response.data;
    },

    createAppointment: async (data: AppointmentCreateData) => {
        const response = await api.post('/appointments/', data);
        return response.data;
    }
};

export default bookingWizardService;
